export const chartColors = [
  "#5AD83A",
  "#00B7F4",
  "#0034E8",
  "#E6007E",
  "#F4A107",
  "#F4423F",
  "#C000DC"
];
